import React from 'react';
import ReactMarkdown from 'react-markdown';

import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(3),
    width: '100%',
  },
  markdown: {
    marginTop: 10,
    marginBottom: 10,
    fontFamily: 'ClarikaGeometric',
    fontSize: 14,
    fontWeight: 400,
  },
  link: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
  },
}));

type Props = {
  about: string;
  link: string;
};

export default function AboutCard({ about, link }: Props) {
  const classes = useStyles();

  return (
    <Grid item xs={12} className={classes.root}>
      <div className={classes.cardContainer}>
        <div>
          <ReactMarkdown className={classes.markdown}>{about}</ReactMarkdown>
        </div>
        {link.length > 0 && (
          <Link href={link} target="blank" className={classes.link}>
            Visit Website
          </Link>
        )}
      </div>
    </Grid>
  );
}
